module.exports = __webpack_public_path__ + "img/logo_4im.379c8abb.jpg";